import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { withRouter } from '../../utils/withRouter';
import PropTypes from 'prop-types';
import { IntlProvider } from "react-intl";
// Creators
import * as actionCreators from '../../actions/actionCreators';
// Components
import Header from '../Header/Header';
import Inquiry from '../Inquiry/Inquiry';
import ContactForm from '../ContactForm/ContactForm';
import Confirm from '../Confirm/Confirm';
import InquiryForm from '../InquiryForm/InquiryForm';
import VerifyPhoneNumber from '../VerifyPhoneNumber/VerifyPhoneNumber';
// Styles
import './App.css';
// Intl
import translations from "../../utils/translations";

class App extends React.Component {

    render() {
        let { inquiryTypes, inquiryData, targetSystems, lang } = this.props;

        return (
            <IntlProvider
                locale={lang}
                messages={translations[lang]}
            >
                <div className="app">
                    <Header lang={lang} />
                    <div className="main-content">
                        <Routes>
                            <Route path="/" exact element={<Inquiry inquiryTypes={inquiryTypes} />}></Route>
                            <Route path="/inquiry-form" exact element={<InquiryForm {...inquiryData} targetSystems={targetSystems} />}></Route>
                            <Route path="/form" exact element={<ContactForm />}></Route>
                            <Route path="/confirm" exact element={<Confirm />}></Route>
                            <Route path="/verify-phone-number" exact element={<VerifyPhoneNumber {...inquiryData} />}></Route>
                        </Routes>
                    </div>
                </div>
            </IntlProvider>
        );
    }
}

App.propTypes = {
    lang: PropTypes.string.isRequired,
    inquiryTypes: PropTypes.array.isRequired,
    targetSystems: PropTypes.array.isRequired,
    inquiryData: PropTypes.object.isRequired
};

let mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

let mapStateToProps = state => ({
    inquiryTypes: state.inquiryTypes,
    targetSystems: state.targetSystems,
    inquiryData: state.inquiryData,
    lang: state.locale.lang
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));